import { render, staticRenderFns } from "./IdeaForm.vue?vue&type=template&id=030d7cc6&scoped=true&"
import script from "./IdeaForm.vue?vue&type=script&lang=js&"
export * from "./IdeaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030d7cc6",
  null
  
)

export default component.exports